<cb-user-profile [sidenav]="sidenav"></cb-user-profile>
<mat-nav-list>
    <mat-list-item (click)="navigateHome()">Dashboard</mat-list-item>
    @if (canSeeSalesDashboard()) {
        <mat-list-item (click)="navigate('/building-consultant-dashboard', $event)"
            >Building Consultant Dashboard
        </mat-list-item>
    }
    @if (canSeeWipComponent()) {
        <mat-list-item (click)="navigate('/wip', $event)"> WIP </mat-list-item>
    }
    @if (canSeeDesignTeamComponent()) {
        <mat-list-item (click)="navigate('/teams/design', $event)"> Design Team </mat-list-item>
    }
    @if (canSeeQSTeamComponent()) {
        <mat-list-item (click)="navigate('/teams/qs', $event)"> QS Team </mat-list-item>
    }
    @if (canSeeAllTeamsComponent()) {
        <mat-list-item (click)="navigate('/teams/all', $event)"> All Teams </mat-list-item>
    }
    @if (canSeeAllTeamsComponent()) {
        <mat-list-item (click)="navigate('/purchase-orders', $event)"
            >Purchase Order Search</mat-list-item
        >
    }
    <mat-divider></mat-divider>
    <mat-accordion multi="true">
        <mat-expansion-panel expanded="true" class="mat-elevation-z0 cb-panel">
            <mat-expansion-panel-header>
                <strong>CRM</strong>
            </mat-expansion-panel-header>
            <mat-nav-list class="cb-panel-list">
                @if (canSeeContactComponent()) {
                    <mat-list-item (click)="navigate('/contacts', $event)"
                        >Contact Search</mat-list-item
                    >
                }
                @if (canSeeLeadComponent()) {
                    <mat-list-item (click)="navigate('/leads/search', $event)"
                        >Lead Search</mat-list-item
                    >
                }
                @if (canSeeMyLeadsComponent()) {
                    <mat-list-item (click)="navigate('/leads', $event)">My Leads</mat-list-item>
                }
                @if (canSeeContactComponent()) {
                    <mat-list-item (click)="navigate('/accounts', $event)"
                        >Client Account Search</mat-list-item
                    >
                }
                @if (canSeeClientSaleComponent()) {
                    <mat-list-item (click)="navigate('/clientsales/search', $event)"
                        >Client Sale Search</mat-list-item
                    >
                }
                @if (canSeeMyClientSalesComponent()) {
                    <mat-list-item (click)="navigate('/clientsales', $event)"
                        >My Client Sales</mat-list-item
                    >
                }
                @if (canSeeHouseLandComponent()) {
                    <mat-list-item (click)="navigate('/house-and-land', $event)">
                        House & Land Search
                    </mat-list-item>
                }
                @if (canSeeStandardPlanComponent()) {
                    <mat-list-item (click)="navigate('/standard-plans', $event)"
                        >Standard Plans
                    </mat-list-item>
                }
            </mat-nav-list>
        </mat-expansion-panel>
    </mat-accordion>
    <mat-divider></mat-divider>
    <mat-accordion multi="true">
        <mat-expansion-panel expanded="true" class="mat-elevation-z0 cb-panel">
            <mat-expansion-panel-header>
                <strong>Build</strong>
            </mat-expansion-panel-header>
            <mat-nav-list class="cb-panel-list">
                @if (canSeeLotComponent()) {
                    <mat-list-item (click)="navigate('/lots', $event)">Lot Search </mat-list-item>
                }

                @if (canSeeLotComponent()) {
                    <mat-list-item (click)="navigate('/temp-lots', $event)"
                        >Temp Lots
                    </mat-list-item>
                }
                @if (canSeeProjectComponent()) {
                    <mat-list-item (click)="navigate('/projects/search', $event)"
                        >Project Search
                    </mat-list-item>
                }
                @if (canSeeSpecificationTemplateComponent()) {
                    <mat-list-item (click)="navigate('/spec-templates', $event)"
                        >Spec Templates
                    </mat-list-item>
                }
                @if (canSeeBuildingProgrammeTemplateComponent()) {
                    <mat-list-item (click)="navigate('/build-programme-templates', $event)"
                        >Build Programme Templates
                    </mat-list-item>
                }
                @if (canGenerateBusinessAccountContract()) {
                    <mat-list-item (click)="navigate('/contract-generation', $event)"
                        >Contract Generation
                    </mat-list-item>
                }
            </mat-nav-list>
        </mat-expansion-panel>
    </mat-accordion>
    <mat-divider></mat-divider>
    <mat-accordion multi="true">
        <mat-expansion-panel expanded="true" class="mat-elevation-z0 cb-panel">
            <mat-expansion-panel-header>
                <strong>Products</strong>
            </mat-expansion-panel-header>
            <mat-nav-list class="cb-panel-list">
                @if (canSeeBusinessAccountComponent()) {
                    <mat-list-item (click)="navigate('/business-accounts', $event)"
                        >Business Accounts
                    </mat-list-item>
                }
                @if (canSeeProductComponent()) {
                    <mat-list-item (click)="navigate('/products', $event)"
                        >Product Catalogue
                    </mat-list-item>
                }
            </mat-nav-list>
        </mat-expansion-panel>
    </mat-accordion>
    <mat-divider></mat-divider>
    <mat-accordion multi="true">
        <mat-expansion-panel expanded="true" class="mat-elevation-z0 cb-panel">
            <mat-expansion-panel-header>
                <strong>Security &amp; Settings</strong>
            </mat-expansion-panel-header>
            <mat-nav-list class="cb-panel-list">
                @if (canSeeSettingsComponent()) {
                    <mat-list-item (click)="navigate('/settings', $event)">Settings</mat-list-item>
                }
                @if (canSeeUsersComponent()) {
                    <mat-list-item (click)="navigate('/users/search', $event)"
                        >User Search</mat-list-item
                    >
                }
                @if (canSeeRolesComponent()) {
                    <mat-list-item (click)="navigate('/security-roles', $event)"
                        >Roles</mat-list-item
                    >
                }
                @if (canSeeConnectionsComponent()) {
                    <mat-list-item (click)="navigate('/connections', $event)"
                        >Connections</mat-list-item
                    >
                }
            </mat-nav-list>
        </mat-expansion-panel>
    </mat-accordion>
</mat-nav-list>
